import { Component } from '@verndale/core';
import anime from 'animejs/lib/anime.es.js';
import Swiper from 'swiper';
import { breakpoints } from '../helpers/constants';

class Module extends Component {
  setupDefaults() {
    this.breakpoint = window.matchMedia(
      `(max-width: ${breakpoints.tablet - 1}px)`
    );
    this.selectedHeader = 0;
    this.runningRolloverAnimation = false;
    this.dom = {
      slider: this.el.querySelector('.featured-content-row__tabs-container'),
      innerContainer: this.el.querySelector('.featured-content-row__inner'),
      tabs: Array.from(this.el.querySelectorAll('.featured-content-row__tab')),
      headers: Array.from(
        this.el.querySelectorAll('.featured-content-row__tab-header')
      ),
      images: Array.from(
        this.el.querySelectorAll('.featured-content-row__tab-info')
      )
    };
    this.removeActiveState();
    this.dom.tabs[0].classList.add('featured-content-row__tab--active');
    this.dom.headers[0].setAttribute('aria-selected', 'true');
    if (this.breakpoint.matches) {
      if (!this.swiper) {
        this.initSlider();
      }
    } else {
      this.destroySlider();
      this.initImageViewer();
    }
  }

  addListeners() {
    this.dom.headers.forEach((header, index) => {
      header.addEventListener('click', () => this.handleTabHeaderClick(index));
      header.addEventListener('keydown', e => this.handleTabHeaderKeydown(e));
    });
    window.addEventListener('resize', () => {
      this.setupDefaults();
    });
  }

  selectTab(index, focus = false) {
    if (this.breakpoint.matches) {
      this.swiper.slideTo(index);
    }
    if (!this.breakpoint.matches && this.selectedHeader !== index) {
      console.log('if');
      this.selectedHeader = index;
      const tab = this.dom.headers[index];
      if (focus) tab.focus();
      this.removeActiveState(this.dom.tabs);
      const tabParent = tab.parentElement;
      tabParent.classList.add('featured-content-row__tab--active');
      tab.setAttribute('aria-selected', 'true');
      this.updateImageViewer(index);
    }
  }

  handleTabHeaderClick(index) {
    this.selectTab(index);
  }

  handleTabHeaderKeydown(e) {
    const keyMapper = { ArrowLeft: -1, ArrowRight: 1 };
    // Return if theres no action for a key
    if (!keyMapper[e.key]) return;
    const nextTabIndex = keyMapper[e.key];
    const lastTabIndex = this.dom.headers.length - 1;

    if (this.selectedHeader + nextTabIndex === -1) {
      this.selectTab(lastTabIndex, true);
    } else if (this.selectedHeader + nextTabIndex > lastTabIndex) {
      this.selectTab(0, true);
    } else {
      this.selectTab(this.selectedHeader + nextTabIndex, true);
    }
  }

  removeActiveState() {
    this.dom.tabs.forEach(tab => {
      tab.classList.remove('featured-content-row__tab--active');
    });
    this.dom.headers.forEach(header => {
      header.setAttribute('aria-selected', 'false');
    });
  }

  initImageViewer() {
    if (!this.el.querySelector('.featured-content-row__image-viewer')) {
      const imageViewer = document.createElement('div');
      imageViewer.classList.add('featured-content-row__image-viewer');
      this.dom.innerContainer.append(imageViewer);
      this.dom.images.forEach((image, index) => {
        const clonedImage = image.cloneNode(true);
        clonedImage.classList.toggle('active', !index);
        clonedImage.classList.toggle('hidden', index);
        imageViewer.append(clonedImage);
      });
    }
  }

  updateImageViewer(newImageIndex) {
    if (this.runningRolloverAnimation) return;
    this.runningRolloverAnimation = true;
    const imageViewer = this.el.querySelector(
      '.featured-content-row__image-viewer'
    );
    const imageViewerImages = Array.from(
      imageViewer.querySelectorAll('.featured-content-row__tab-info')
    );
    const currentImageIndex = imageViewerImages.findIndex(image =>
      image.classList.contains('active')
    );
    const newImageInView = imageViewerImages[newImageIndex];
    const newImageInViewCaption = newImageInView.querySelector(
      '.featured-content-row__tab-note'
    );
    const direction = newImageIndex > currentImageIndex ? '-100%' : '100%';
    const currentImageInView = imageViewerImages[currentImageIndex];
    newImageInView.classList.remove('hidden');
    anime({
      targets: currentImageInView,
      translateX: ['0%', direction],
      easing: 'easeInOutQuad',
      duration: 400,
      complete: () => {
        this.runningRolloverAnimation = false;
        newImageInView.classList.add('active');
        currentImageInView.classList.add('hidden');
        currentImageInView.classList.remove('active');
        currentImageInView.removeAttribute('style');
      }
    });
    if (newImageInViewCaption) {
      anime({
        targets: newImageInViewCaption,
        translateY: ['20%', '0%'],
        opacity: ['0%', '100%'],
        easing: 'easeInOutQuad',
        duration: 200,
        delay: 200
      });
    }
  }

  initSlider() {
    this.swiper = new Swiper(this.dom.slider, {
      slidesPerView: 1.3,
      spaceBetween: 33,
      threshold: 8,
      watchOverflow: true,
      watchSlidesVisibility: true,
      slidesOffsetAfter: 200, //Offset makes last card selectable
      breakpoints: {
        [breakpoints.tablet]: {
          slidesOffsetAfter: 500,
          slidesPerView: 4
        },
        [breakpoints.laptop]: {
          slidesOffsetAfter: 0,
          spaceBetween: 0
        }
      }
    });
  }

  destroySlider() {
    if (this.swiper) {
      this.swiper.detachEvents();
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

export default Module;
